<section class="container my-5">
    <h2
        class="text-center mb-4 fw-normal"
        [innerHTML]="titleKey | cmsText | async"
    ></h2>
    <div
        *ngIf="showEnvironmentTexasLogo"
        class="row justify-content-center mb-2"
    >
        <div class="logo-wrapper col-md-2 col-4 p-3">
            <img
                class="logo h-100 w-100"
                [attr.src]="'environment-texas-logo' | cmsImageSrc | async"
                [attr.alt]="'environment-texas-logo' | cmsImageAlt | async"
            />
        </div>
    </div>
    <div class="row justify-content-center">
        <ng-container *ngFor="let logoCmsKey of logosCmsKeys$ | async">
            <div class="logo-wrapper col-md-2 col-4 p-3">
                <img
                    class="logo h-100 w-100"
                    [attr.src]="logoCmsKey | cmsImageSrc | async"
                    [attr.alt]="logoCmsKey | cmsImageAlt | async"
                />
            </div>
        </ng-container>
    </div>
</section>
